/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
//console.log( 'Hello World! (from sp/main-banner block)' );
/* eslint-enable no-console */
var $ = jQuery.noConflict();

/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
//console.log( 'Hello World! (from sp/main-banner block)' );
/* eslint-enable no-console */

var $ = jQuery.noConflict();

document.addEventListener("DOMContentLoaded", function () {
	setProcess();
});

function setProcess() {
	var splide = new Splide("#sp-process-carousel", {
		type: "fade",
		// rewind: "true",
		pagination: true,
		keyboard: true,
		// height: "500px",
		// direction: "ttb",
		// perPage: 8,
	});

	var thumbnails = document.getElementsByClassName("path-point");
	var thumbnailTexts = document.getElementsByClassName("path-point-text");
	var current;

	for (var i = 0; i < thumbnails.length; i++) {
		initThumbnail(thumbnails[i], i);
	}
	for (var i = 0; i < thumbnailTexts.length; i++) {
		initThumbnail(thumbnailTexts[i], i);
	}

	function initThumbnail(thumbnail, index) {
		thumbnail.addEventListener("click", function () {
			splide.go(index);
		});
	}

	splide.on("mounted move", function () {
		var thumbnail = thumbnails[splide.index];

		if (thumbnail) {
			if (current) {
				current.classList.remove("fill-white");
			}

			thumbnail.classList.add("fill-white");
			// $(thumbnail).removeClass('path-point', function (index, currentClass) {
			// 	console.log("class:", currentClass, ", index:", index);
			// 	return "delay-[0s]";
			// });

			$(thumbnail).css("transition-delay", "0ms");
			current = thumbnail;
		}
	});

	splide.mount();
}
